import { render, staticRenderFns } from "./PatientChartCards.vue?vue&type=template&id=20db43ee&"
import script from "./PatientChartCards.vue?vue&type=script&lang=js&"
export * from "./PatientChartCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports